var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 6.58172 5.58172 3 10 3C14.4183 3 18 6.58172 18 11C18 15.4183 14.4183 19 10 19C5.58172 19 2 15.4183 2 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5129 13.9803C9.49787 13.9977 9.4821 14.0147 9.46557 14.0312C9.10139 14.3954 8.51093 14.3954 8.14675 14.0312L5.83881 11.7233C5.47463 11.3591 5.47463 10.7687 5.83881 10.4045C6.20299 10.0403 6.79345 10.0403 7.15763 10.4045L8.82188 12.0687L12.8175 8.07314C13.1817 7.70896 13.7721 7.70896 14.1363 8.07314C14.5005 8.43732 14.5005 9.02778 14.1363 9.39196L9.68209 13.8462C9.62989 13.8984 9.57305 13.9431 9.5129 13.9803Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C6.41015 17.5 3.5 14.5899 3.5 11H0.5C0.5 16.2467 4.75329 20.5 10 20.5V17.5ZM16.5 11C16.5 14.5899 13.5899 17.5 10 17.5V20.5C15.2467 20.5 19.5 16.2467 19.5 11H16.5ZM10 4.5C13.5899 4.5 16.5 7.41015 16.5 11H19.5C19.5 5.75329 15.2467 1.5 10 1.5V4.5ZM10 1.5C4.75329 1.5 0.5 5.75329 0.5 11H3.5C3.5 7.41015 6.41015 4.5 10 4.5V1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.074a16a436d5a7c383269503849f8ad2.svg";
export { ForwardRef as ReactComponent };